"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const bridge_1 = require("../bridge");
const errors_1 = require("../errors");
const callBridge = (0, bridge_1.getCallBridge)();
const noop = () => { };
class Modal {
    constructor(opts) {
        var _a, _b;
        this.resource = (opts === null || opts === void 0 ? void 0 : opts.resource) || null;
        this.onClose = (opts === null || opts === void 0 ? void 0 : opts.onClose) || noop;
        this.size = (opts === null || opts === void 0 ? void 0 : opts.size) || 'medium';
        this.context = (opts === null || opts === void 0 ? void 0 : opts.context) || {};
        this.closeOnEscape = (_a = opts === null || opts === void 0 ? void 0 : opts.closeOnEscape) !== null && _a !== void 0 ? _a : true;
        this.closeOnOverlayClick = (_b = opts === null || opts === void 0 ? void 0 : opts.closeOnOverlayClick) !== null && _b !== void 0 ? _b : true;
    }
    async open() {
        try {
            const success = await callBridge('openModal', {
                resource: this.resource,
                onClose: this.onClose,
                size: this.size,
                context: this.context,
                closeOnEscape: this.closeOnEscape,
                closeOnOverlayClick: this.closeOnOverlayClick
            });
            if (success === false) {
                throw new errors_1.BridgeAPIError('Unable to open modal.');
            }
        }
        catch (err) {
            throw new errors_1.BridgeAPIError('Unable to open modal.');
        }
    }
}
exports.Modal = Modal;
